{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-300200x",
  "sheetId": "AnalysisOfProfitOrLossByFunction",
  "label": "[310100] Detailed analysis and breakdown of expenses by function of expense method (MFRS)",
  "description": "Detailed analysis and breakdown of expenses by function of expense method",
  "controls": [
    {
      "qname": "ssmt:AnalysisOfProfitOrLossByFunctionHeader",
      "label": "Analysis of profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 1
      }
    },
    {
      "qname": "ssmt:StatementOfProfitOrLossHeader",
      "label": "Statement of profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 2
      }
    },
    {
      "qname": "ssmt:RevenueHeader",
      "label": "Revenue",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt:RevenueFromSaleOfGoodsHeader",
      "label": "Revenue from sale of goods",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:RevenueFromSaleOfTelecommunicationEquipment",
      "label": "Revenue from sale of broadband and telecommunication",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromSaleOfProperty",
      "label": "Revenue from property development",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromSaleOfConstructionContracts",
      "label": "Revenue from construction contracts",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromSaleOfCleanWaterTreatmentAndDisposalOfWasteWater",
      "label": "Revenue from sale of clean water, treatment and disposal of waste water",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromSaleOfFoodAndBeverage",
      "label": "Revenue from sale of food and beverage",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromSaleOfAgriculturalProduce",
      "label": "Revenue from sale of agricultural produce",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromSaleOfOilAndGasProducts",
      "label": "Revenue from sale of oil and gas products",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromSaleOfOtherGoods",
      "label": "Revenue from sale of other goods",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromSaleOfGoods",
      "label": "Total revenue from sale of goods",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:RevenueFromRenderingOfServicesHeader",
      "label": "Revenue from rendering of services",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromEntertainmentOperations",
      "label": "Revenue from rendering of entertainment services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRenderingOfTelecommunicationServices",
      "label": "Revenue from rendering of telecommunication services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRenderingOfTransportServices",
      "label": "Revenue from rendering of transportation services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRenderingOfInformationTechnologyServices",
      "label": "Revenue from rendering of information technology services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromEducationalServices",
      "label": "Revenue from rendering of educational services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromHealthcareServices",
      "label": "Revenue from rendering of healthcare services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRenderingOfCargoAndMailTransportServices",
      "label": "Revenue from rendering of shipping and shipping related services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RevenueFromRenderingOfOtherServices",
      "label": "Revenue from rendering of other services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRenderingOfServices",
      "label": "Total revenue from rendering of services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:InterestIncomeHeader",
      "label": "Interest income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:InterestIncomeOnLoansAndReceivables",
      "label": "Interest income on loans, advances and financing",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:InterestIncomeOnOtherFinancialAssets",
      "label": "Interest income on other financial assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromInterest",
      "label": "Total interest income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:OtherFeeAndCommissionIncomeHeader",
      "label": "Other fee and commission income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:BrokerageFeeIncome",
      "label": "Gross brokerage and other charges",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PortfolioAndOtherManagementFeeIncome",
      "label": "Underwriting commissions and fund management income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherFeeAndCommissionIncome",
      "label": "Other fee and commission income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:FeeAndCommissionIncome",
      "label": "Total other fee and commission income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromDividends",
      "label": "Dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RentalIncome",
      "label": "Rental income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRoyalties",
      "label": "Royalty income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherRevenue",
      "label": "Other revenue",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Revenue",
      "required": true,
      "label": "Total revenue",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:CostOfSalesHeader",
      "label": "Cost of sales",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mfrs:CostOfInventories",
      "label": "Cost of inventories",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ConstructionContractCost",
      "label": "Construction contract costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:EnergyExpense",
      "label": "Energy costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PropertyDevelopmentAndProjectManagementExpense",
      "label": "Property development costs",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherCostOfSales",
      "label": "Other cost of sales",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:CostOfSales",
      "required": true,
      "label": "Total cost of sales",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:OtherIncomeHeader",
      "label": "Other income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mfrs:AmortisationOfDeferredIncome",
      "label": "Deferred income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BadDebtsRecovered",
      "label": "Bad debts recovered",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherIncomeDividend",
      "label": "Dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherIncomeRoyaltyAndFranchise",
      "label": "Royalty/franchise income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:WriteBackOfFuelCost",
      "label": "Write back of fuel cost",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:IncomeFromReimbursementsUnderInsurancePolicies",
      "label": "Income from reimbursements under insurance policies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:GrantsOrIncentivesReceivedByMalaysianGovernmentOrAgencies",
      "label": "Grant or incentives by Malaysian government or it's agencies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:GrantsOrIncentivesReceivedByForeignGovernmentOrAgencies",
      "label": "Grant or incentives by foreign government or it's agencies",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ContributionsReceivedByLocalContributor",
      "label": "Contributions or donations by local contributor",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ContributionsReceivedByForeignContributor",
      "label": "Contributions or donations by foreign contributor",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ContributionsReceivedByUnknownContributor",
      "label": "Contributions or donations by unknown contributor",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ForeignExchangeGainHeader",
      "label": "Foreign exchange gain",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:RealisedGainOnForeignExchange",
      "label": "Realised gain on foreign exchange",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:UnrealisedGainOnForeignExchange",
      "label": "Unrealised gain on foreign exchange",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:GainsOnForeignExchange",
      "label": "Total foreign exchange gain",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:GainOnDisposalOfSubsidiariesAssociatesAndJointVenturesHeader",
      "label": "Gain on disposal of subsidiaries, associates and joint ventures",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:GainsFromDisposalOfSubsidiaries",
      "label": "Gain on disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:GainsFromDisposalOfAssociates",
      "label": "Gain on disposal of associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:GainsFromDisposalOfJointVentures",
      "label": "Gain on disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:GainsOnDisposalOfSubsidiaryJointVenturesAndAssociates",
      "label": "Total gain on disposal of subsidiaries, associates and joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mfrs:GainsOnDisposalOfOtherInvestments",
      "label": "Gain on disposal from other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:GainsOnDisposalsOfPropertyPlantAndEquipment",
      "label": "Gains on disposal of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:GainsOnDisposalsOfNoncurrentAssets",
      "label": "Gains on disposals of other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherGainsRecognisedInProfitOrLossFairValueMeasurementAssets",
      "label": "Other gains recognised in profit or loss, fair value measurement, assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ReversalOfImpairmentLossRecognisedInProfitOrLossHeader",
      "label": "Reversal of impairment loss recognised in profit or loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:ReversalOfImpairmentLossRecognisedInProfitOrLossLoansAndAdvances",
      "label": "Reversal of impairment loss on receivables",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReversalOfImpairmentLossRecognisedInProfitOrLossInvestmentProperty",
      "label": "Reversal of impairement in development expenditure",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ReversalOfImpairmentLossInLandHeldForDevelopment",
      "label": "Reversal of impairment in land held for property development",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReversalOfImpairmentLossRecognisedInProfitOrLossPropertyPlantAndEquipment",
      "label": "Reversal of impairment in property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:ReversalOfImpairmentLossForOtherAssets",
      "label": "Reversal of impairment in other assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ReversalOfImpairmentLossRecognisedInProfitOrLoss",
      "label": "Total reversal of impairment loss recognised in profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-full:ReversalOfInventoryWritedown",
      "label": "Reversal of inventories written down to net realisable value",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherInterestIncome",
      "label": "Interest income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:IncomeFromManagementFees",
      "label": "Management fees",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NetDepositsRecognised",
      "label": "Net deposits recognised",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:GainsOnChangeInFairValueOfDerivatives",
      "label": "Net fair value gain on derivatives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:FairValueGainOnRecycleOfForexReserveUponDisposalOfSubsdiaries",
      "label": "Net fair value gain on recycle of forex reserve upon disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherFeesAndCommissionIncome",
      "label": "Other fee and commission",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherRentalIncome",
      "label": "Other rental income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherRentalIncomeOnLandAndBuildings",
      "label": "Rental income on land and buildings",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:MiscellaneousOtherOperatingIncome",
      "label": "Other miscellaneous income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherIncome",
      "required": true,
      "label": "Total other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:OtherExpensesHeader",
      "label": "Other expenses",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 2
      }
    },
    {
      "qname": "ssmt:AuditorsRemunerationHeader",
      "label": "Auditor's remuneration",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ifrs-full:AuditorsRemunerationForAuditServices",
      "label": "Auditor's remuneration for audit services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:AuditorsRemunerationForOtherServices",
      "label": "Auditor's remuneration for other services",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:AuditorsRemuneration",
      "label": "Total auditor's remuneration",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-full:AmortisationExpense",
      "label": "Amortisation expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:DepreciationPropertyPlantAndEquipment",
      "label": "Depreciation of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:NaturalDisasterRelatedExpenses",
      "label": "Natural disaster related expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:LossOnDisposalOfSubsidiariesAssociatesAndJointVenturesHeader",
      "label": "Loss on disposal of subsidiaries, associates and joint ventures",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mfrs:LossOnDisposalOfSubsidiaries",
      "label": "Loss on disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:LossOnDisposalOfAssociates",
      "label": "Loss on disposal of associates",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:LossOnDisposalOfJointVentures",
      "label": "Loss on disposal of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:LossOnDisposalOfSubsidiariesAssociatesAndJointVentures",
      "label": "Total loss on disposal of subsidiaries, associates and joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-full:LossesOnDisposalsOfInvestments",
      "label": "Loss on disposal from other investments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LossesOnDisposalsOfPropertyPlantAndEquipment",
      "label": "Losses on disposals of property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:LossesOnDisposalsOfNoncurrentAssets",
      "label": "Loss on disposal of other non-current assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherLossesRecognisedInProfitOrLossFairValueMeasurementAssets",
      "label": "Other losses recognised in profit or loss, fair value measurement, assets",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RentalExpense",
      "label": "Rental expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RoyaltyExpense",
      "label": "Royalty expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:EmployeeBenefitsExpenseHeader",
      "label": "Employee benefits expense",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ifrs-full:WagesAndSalaries",
      "label": "Wages, salaries and others",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BonusExpenses",
      "label": "Bonus",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ExpenseFromSharebasedPaymentTransactionsWithEmployees",
      "label": "Share-based compensation expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:EmployeeShareBasedPayment",
      "label": "Share option expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:SocialSecurityContributions",
      "label": "Social security contributions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PostemploymentBenefitExpenseDefinedBenefitPlans",
      "label": "Defined benefit plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:PostemploymentBenefitExpenseDefinedContributionPlans",
      "label": "Defined contribution plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherLongtermBenefits",
      "label": "Other long-term employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherShorttermEmployeeBenefits",
      "label": "Other short-term employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherEmployeeExpense",
      "label": "Other employee expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:EmployeeBenefitsExpense",
      "label": "Total employee benefits expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:DirectorsRemunerationHeader",
      "label": "Director's remuneration",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 3
      }
    },
    {
      "qname": "ssmt-mfrs:WagesAndSalariesToDirectors",
      "label": "Salaries and other emoluments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BonusToDirectors",
      "label": "Bonus",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:BenefitsInKindExpenses",
      "label": "Benefits-in-kind",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsFees",
      "label": "Fees",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:PerformanceIncentives",
      "label": "Performance incentives",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RetirementBenefitsDefinedBenefitPlans",
      "label": "Defined benefit plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RetirementBenefitsDefinedContributionPlans",
      "label": "Definted contribution plans",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:KeyManagementPersonnelCompensationSharebasedPayment",
      "label": "Share option expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherDirectorsRemuneration",
      "label": "Other emoluments",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsRemuneration",
      "label": "Total director's remuneration",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherMiscellaneousExpenses",
      "label": "Other miscellaneous expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherExpenseByFunction",
      "required": true,
      "label": "Total other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ssmt:FinanceIncomeHeader",
      "label": "Finance income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "dualColumn": true,
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:InterestIncomeDueFromRelatedParties",
      "label": "Finance income due from related parties",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherFinanceIncome",
      "label": "Other finance income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:FinanceIncome",
      "required": true,
      "label": "Total finance income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true
      }
    }
  ],
  "roleId": "role-310100-mfrs",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-300200x",
  "taxonomy": "FS-MFRS"
}